// extracted by mini-css-extract-plugin
export default {"m":"StandsItem_m__wE6CB"};